import { render, staticRenderFns } from "./DebtCollectingForm.vue?vue&type=template&id=3b9bc918"
import script from "./DebtCollectingForm.vue?vue&type=script&lang=js"
export * from "./DebtCollectingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports